import { card, error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const changeCardPin = gql`
  mutation changeCardPin(
    $idempotencyId: IdempotencyToken!
    $input: ChangeCardPinInput!
  ) {
    changeCardPin(idempotencyId: $idempotencyId, input: $input) {
      ... on ChangeCardPinSuccess {
        card {
          ...card
        }
        __typename
      }
      ... on ChangeCardPinIncorrectPinError {
        ...error
        __typename
      }

      ... on ChangeCardPinMatchesOldError {
        ...error
        __typename
      }

      ... on ChangeCardPinTooManyAttemptsError {
        ...error
        __typename
      }
      ... on ChangeCardPinError {
        ...error
        __typename
      }
    }
  }
  ${card}
  ${error}
`;
export default changeCardPin;
